import { Action } from '@ngrx/store';

export const GET_ENTERTAINMENT_TICKET_TYPE = '[Entertainment Event] Get Entertainment Ticket Type';
export const GET_ENTERTAINMENT_TICKET_TYPE_SUCCESS = '[Entertainment Event] Get Entertainment Ticket Type Success';
export const GET_ENTERTAINMENT_TICKET_TYPE_FAIL = '[Entertainment Event] Get Entertainment Ticket Type Fail';

export class GetEntertainmentTicketType implements Action {
  readonly type = GET_ENTERTAINMENT_TICKET_TYPE;
  constructor(public payload: any) {}
}
export class GetEntertainmentTicketTypeSuccess implements Action {
  readonly type = GET_ENTERTAINMENT_TICKET_TYPE_SUCCESS;
  constructor(public payload: any) {}
}
export class GetEntertainmentTicketTypeFail implements Action {
  readonly type = GET_ENTERTAINMENT_TICKET_TYPE_FAIL;
  constructor(public payload: any) {}
}

export type EntertainmentEventTicketTypeAction =
  | GetEntertainmentTicketType
  | GetEntertainmentTicketTypeSuccess
  | GetEntertainmentTicketTypeFail;
